import { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { UnControlled as CodeMirror } from 'react-codemirror2';
import copy from 'copy-to-clipboard';
import Button from '../Button';
import { API_NEW } from 'src/API';

import 'codemirror/mode/javascript/javascript';
import 'codemirror/lib/codemirror.css';
// import 'codemirror/theme/mdn-like.css';
import './code-viewer.scss';

import { ReactComponent as CopyIcon } from 'src/Themes/assets/copy.svg';

interface ICodeViewerProps extends HTMLAttributes<HTMLDivElement> {
	value: string;
}

const CodeViewer: FC<ICodeViewerProps> = (props) => {
	const { value, className } = props;

	const copyHandler = () => {
		const isSuccess = copy(value, {
			debug: window.isDev,
		});
		const msg = isSuccess
			? 'Скопировано в буфер обмена'
			: 'Ошибка при копировании значения в буфер обмена';
		API_NEW.showToast(isSuccess, msg);
	};

	return (
		<div className="code-viewer__wrapper">
			<Button
				outline
				className="code-viewer__copy"
				size="min"
				onClick={copyHandler}
			>
				<CopyIcon />
			</Button>
			<CodeMirror
				value={value}
				className={classNames('code-viewer', className)}
				options={{
					mode: 'javascript',
					singleCursorHeightPerLine: false,
					showCursorWhenSelecting: false,
					lineNumbers: true,
					readOnly: true,
				}}
			/>
		</div>
	);
};

export default CodeViewer;
